import React  from 'react';
import UserComponentProto from './user-proto.jsx';


export default function renderDateInView(id, props) {
    return <UserComponentProto renderMode="view" id={id} {...props} />;
}